export enum ErrorWarningSummaryStateEnum {
    error = 0,
    warning = 1
}
